// eslint-disable-next-line no-restricted-imports
import {
  EventData,
  MessageUnreadCount as IMessageUnreadCount,
  MessageUnreadCountTypeEnum as IMessageUnreadCountTypeEnum,
  OrderTypeEnum as IOrderTypeEnum,
  PositionChanged as IPositionChanged,
  PriceAlertActivated as IPriceAlertActivated,
  PriceAlertActivatedTypeEnum as IPriceAlertActivatedTypeEnum,
  ToastTypeEnum as IToastTypeEnum,
  Order,
} from '@eih-netbroker/api-user-stream';

export const UserStreamMessageType = {
  MessageUnreadCount: IMessageUnreadCountTypeEnum.Messageunreadcount,
  Order: IOrderTypeEnum.Order,
  PriceAlertActivated: IPriceAlertActivatedTypeEnum.Pricealertactivated,
  Toast: IToastTypeEnum.Toast,
  PositionChanged: 'positionchanged',
  KeepAlive: 'keepalive',
};

export type UserStreamMessage = EventData & {
  $type:
    | typeof IMessageUnreadCountTypeEnum.Messageunreadcount
    | typeof IOrderTypeEnum.Order
    | typeof IPriceAlertActivatedTypeEnum.Pricealertactivated
    | typeof IToastTypeEnum.Toast
    | 'positionchanged';
};

export type UserStreamOrder = Order;

export type MessageUnreadCount = IMessageUnreadCount;

export type PositionChanged = IPositionChanged;

export type PriceAlertActivated = IPriceAlertActivated;
